<template>
    <v-container grid-list-xs>
        <v-layout justify-center> 
            <v-flex xs6>
                <v-form ref="form" v-model="valid" lazy-validation>
                <v-text-field
                    v-model="product.code"  
                    :disabled="this.$store.getters.get_edit_mode == '1'"
                    :rules="codeRules"
                    :counter="10"
                    label="Code"
                    required
                ></v-text-field>
                <v-text-field
                    v-model="product.name"
                    :rules="nameRules"                    
                    label="Name"
                    required />
                <v-text-field
                    v-model="product.descrip"
                    label="description"
                    :rules="otherRules"  
                    required />
                <v-text-field
                    v-model="product.ingredients"
                    label="ingredients"
                    :rules="otherRules"  
                    required />
                <v-text-field
                    v-model="product.price"
                    label="price"
                    type = "number"
                    :rules="otherRules"  
                    required />
                <v-combobox
                    v-model="product.category"
                    :items="cat_combo"
                    label="Category"
                    required
                ></v-combobox>  

                <v-combobox
                    v-model="product.active"
                    :items="act_combo"
                    label="Active"
                    required
                ></v-combobox>

                <v-row>
                    <v-img
                    v-if="imageURL"
                    :src="imageURL"
                    height="200"
                    width="200"
                    class="mt-3"
                    ></v-img>
                </v-row>  
 
                <v-row>
                    <v-img
                    v-if="p_edit()"
                    :src="oldimageURL"
                    height="200"
                    width="200"
                    class="mt-3"
                    ></v-img>
                </v-row>  

                <br>
                <v-row>
                    <input @change="onFileSelected"  ref="fileupload"  type="file" name="" id="" />
                </v-row>  
                <br>    
                <br>
                <v-btn class="font-weight-light" tile :disabled="!valid"
                    @click="submit">
                    submit
                </v-btn>
                <v-btn class="font-weight-light" tile color="black" dark   
                :disabled="this.$store.getters.get_edit_mode == '1'"
                @click.native="clear">clear</v-btn>


                </v-form>
            </v-flex>
        </v-layout>  
    </v-container>

</template>

<script>
export default {
  data() {
    return {
        valid: true,
        product:{
            code: '',
            name: '',
            descrip:'',
            ingredients:'',
            price:'',
            category:'meal',
            select_day:[],
            image: '',
            active: 'AC',
            imagename : '',
        },    
        imageURL : null,
        oldimageURL : 'https://ws.plantifulbkk.shop/images/' ,
        cng_img : 0,
        act_combo :["AC","IN"],
        cat_combo :[],
        p_active : true,
        sel1_day: [],
        items_day: [
          'Mon',
          'Tue',
          'Wed',
          'Thu',
          'Fri',
        ],
        codeRules: [
          v => !!v || 'This field is required',
        ],
        nameRules: [
          v => !!v || 'This field is required',
        ],        
        passRules: [
          v => !!v || 'Password is required',
          v => (v && v.length >= 6) || 'This field must be more than 6 characters'
        ],
        otherRules: [
          v => !!v || 'This field is required',
        ],

    }
  },
    created () {
        this.get_cat()
        if ( this.$store.getters.get_edit_mode == '1'){
            this.edit_data ()

        }
    },
  methods: {
    submit () {
        if (this.$refs.form.validate()) {
            if ( this.$store.getters.get_edit_mode == '0'){
                this.add_product(this.product.code)
            }
            if ( this.$store.getters.get_edit_mode == '1'){                
                this.edit_product()
            }
        }
      },
    onFileSelected(event) {

      var fileData =  event.target.files[0];
        this.cng_img = 1
      const reader = new FileReader();
      reader.onload = event => {
        // for preview
        this.imageURL = event.target.result;
      };
      reader.readAsDataURL(fileData);

      // for upload
      this.product.image = fileData
      this.product.imagename = fileData.name
    },
    clear () {

        this.$refs.form.reset()
        this.imageURL = null
        this.product.image = null
        this.product.imagename = ''
        this.$refs.fileupload.value=null
      },
    edit_data () {
        const vm = this;
        vm.axios.get('https://ws.plantifulbkk.shop/get_product_edit.php',{
            params: {
                scode: this.$store.getters.get_user_code ,
            }
        }).then(response => {
        this.product = JSON.parse(JSON.stringify(response.data))
        this.oldimageURL = this.oldimageURL + this.product.image

        if ( this.product.select_day.includes('Mon') ){
            this.sel1_day.push('Mon')
        }
        if ( this.product.select_day.includes('Tue') ){
            this.sel1_day.push('Tue')
        }
        if ( this.product.select_day.includes('Wed') ){
            this.sel1_day.push('Wed')
        }
        if ( this.product.select_day.includes('Thu') ){
            this.sel1_day.push('Thu')
        }
        if ( this.product.select_day.includes('Fri') ){
            this.sel1_day.push('Fri')
        }
        /*
        if ( this.product.select_day != '' ){
            this.product.select_day = this.product.select_day.split(",")
        }else{
            this.product.select_day = null
        }    
        */
        console.log(result)
        });
      },
      edit_product(){
            const vm = this;

            if ( this.cng_img == 1 ){
                this.uploadimage()
            }

            this.product.select_day =  this.sel1_day
            vm.axios.get("https://ws.plantifulbkk.shop/post_edit_product.php",{
                    params: {
                        scode: this.product ,
                    }
                }).then(result=>{
                        console.log(result.data)
                        this.$refs.form.reset()
                        alert("Edit Product Complete")
                        this.$router.push('/product')
                    })
                .catch(function (error) {
                        alert("Error : Cannot Edit Product !!")
                        console.log(error)
            })

      },
      add_product( datajson){

        const vm = this;
        vm.axios.get('https://ws.plantifulbkk.shop/get_chk_product_code.php',{
            params: {
                scode: this.product.code ,
            }
        }).then(response => {

            if ( response.data == 'code_is_correct'  ){
                   
                this.uploadimage()

                vm.axios.get("https://ws.plantifulbkk.shop/post_add_product.php",{
                    params: {
                        scode: this.product ,
                    }
                }).then(result=>{
                        console.log(result.data)
                        this.clear () 
                        alert("Add new Product Complete")
                    })
                .catch(function (error) {
                        alert("Error : Cannot Add new Product !!")
                        console.log(error)
                    })

            }else{
                alert("Product code Duplicate or not correct !!")
            }
        });
      },
      uploadimage(){
            const vm = this;

            let formData = new FormData();
            formData.append('file', this.product.image );
  
            vm.axios.post('https://ws.plantifulbkk.shop/post_image.php',
                formData,
                {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
              }
            ).then(function(data){
              console.log(data.data);
            })
            .catch(function(){
              console.log('FAILURE!!');
            });
      },
        getProductImage() {
            if (this.product.image.length > 100) {
                return this.product.image;
            } else {
                return this.$options.filters.imageUrl(this.product.image);
                // return `${imageUrl}/${this.product.image}`;
            }
        },
        p_edit() {
            if ( this.$store.getters.get_edit_mode == '1' && this.cng_img == 0 ){
                return true
            }else{
                return false
            }
        },
        get_cat(){
            const vm = this;
            vm.axios.get('https://ws.plantifulbkk.shop/get_category.php',{
                params: {
                }
            }).then(response => {
            this.cat_combo = JSON.parse(JSON.stringify(response.data))
            console.log(result)
            });

        },
    }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/pages/add_product.vue